import BlogSection from '../components/BlogSection';
import ServicesSection from '../components/ServicesSection';
import VehicleShowcaseCards from '../components/VehicleShowcaseCards';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import FIFAPopup from '../components/FIFAPopup';
import CitiesSection from '../components/CitiesSection';

function Home() {
  return (
    <>

    <FIFAPopup/>
      {/* Hero Section with Background Image */}
      <section 
        className="relative w-full h-[60vh] md:h-[70vh] lg:h-[80vh] xl:h-[100vh] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(blog11.png)'
        }}
      >
        <Header/>
        
        {/* Centered Content */}
        <div className="relative z-20 flex flex-col items-center justify-center h-full text-center text-white px-4">
          {/* Main Headline */}
          <h1 className="font-bold mb-2 lg:mb-2 text-2xl md:text-3xl lg:text-4xl mt-8 drop-shadow-lg leading-tight">
            Experience Luxury in Every Mile
          </h1>
          
          {/* Phone Number */}
          <a href="tel:+17182004140" className="text-logo-green font-bold text-4xl hover:text-white transition-colors mb-5 mt-2 block">
                      (718) 200 4140
                    </a>
          
          {/* Slogan */}
          <p className="text-white text-sm md:text-lg lg:text-3xl mb-6 md:mb-8 lg:mb-8 xl:mb-10 font-medium lg:font-bold drop-shadow-md leading-relaxed px-2 lg:px-0">
            We offer a fleet of luxurious cars with all the amenities, driven by professional chauffeurs. Your comfort and satisfaction are our top priorities.
          </p>
          
          {/* Call-to-Action Buttons */}
          <div className="flex flex-col lg:flex-row gap-3 lg:gap-4 justify-center items-center w-full max-w-sm lg:max-w-none">
            {/* CALL US NOW Button */}
            <a 
              href="tel:+17182004140" 
              className="bg-black text-white border-2 border-white px-4 md:px-6 lg:px-8 xl:px-12 py-2.5 md:py-3 lg:py-4 xl:py-5 font-bold text-sm md:text-base lg:text-lg xl:text-2xl transition-all duration-300 hover:bg-gray-900 shadow-lg w-full lg:w-auto text-center rounded-full min-h-[44px]"
            >
              CALL NOW
            </a>

            {/* BOOK NOW Button */}
            <a 
              href="/booknow" 
              className="bg-white text-black border-2 border-black px-4 md:px-6 lg:px-8 xl:px-12 py-2.5 md:py-3 lg:py-4 xl:py-5 font-bold text-sm md:text-base lg:text-lg xl:text-2xl transition-all duration-300 hover:bg-gray-100 shadow-lg w-full lg:w-auto text-center rounded-full min-h-[44px]"
            >
              BOOK NOW
            </a>
          </div>
        </div>
      </section>

      {/* Cities We Serve Section */}
      <CitiesSection />

      {/* Premier Service Section - Mobile: Image First, Desktop: Image Left, Text Right */}
      <section className="bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
            {/* Image Side - First on mobile, left on desktop */}
            <div className="order-1 lg:order-1">
              <img 
                src="fleet6.png" 
                alt="Luxury Fleet" 
                className="w-full h-48 md:h-64 lg:h-80 xl:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side - Second on mobile, right on desktop */}
            <div className="order-2 lg:order-2">
              <h2 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-bold text-black mb-2 md:mb-3 lg:mb-4 leading-tight">
                New York Limo Service
              </h2>
              <p className="text-sm md:text-base lg:text-lg mb-2 md:mb-3 lg:mb-4 leading-relaxed text-gray-900">
               Experience the ultimate in luxury and comfort with Majestic Voyage NYC Limo – your trusted partner for premium limousine services in New York City. Whether it's airport transfers, corporate events, weddings, or a night out in town, we provide professional chauffeurs and high-end vehicles to make every journey special.
              </p>
              <p className="text-sm md:text-base lg:text-lg mb-3 md:mb-4 lg:mb-6 leading-relaxed text-gray-900">
              Our commitment to punctuality, cleanliness, and customer satisfaction makes us the preferred choice for thousands of clients across NYC. We believe in providing not just a ride – but an experience that reflects class, safety, and reliability.
              </p>
              <div className="flex flex-col md:flex-row gap-3 md:gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-4 md:px-6 lg:px-8 py-2.5 md:py-3 text-sm md:text-base font-semibold hover:bg-gray-900 transition-colors text-center"
                >
                  BOOK NOW
                </a>
                
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-4 md:px-6 lg:px-8 py-2.5 md:py-3 text-sm md:text-base font-semibold hover:bg-gray-100 transition-colors text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <ServicesSection />

      {/* FIFA World Cup 2026 Section */}
      <section
        className="relative w-full min-h-[500px] md:min-h-[500px] lg:min-h-[600px] flex items-center"
        style={{
          backgroundImage: "url('/fifaw.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <img 
            src="fifa4.png" 
            alt="" 
            className="h-[120px] md:h-[200px] mx-auto mb-4 md:mb-6"
          />
          {/* TEXT CONTENT ONLY - Centered */}
          <div className="text-white text-center max-w-3xl mx-auto">
            
            <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-white mb-3 md:mb-4">
              Score Big Savings This FIFA World Cup 2026
            </h2>

            <p className="text-gray-200 text-sm md:text-base lg:text-lg mb-4 md:mb-6 leading-relaxed px-2 md:px-0">
              Cheer for your team and save on your ride! Enjoy up to{" "}
              <span className="text-white font-semibold text-base md:text-lg lg:text-xl">20% OFF</span> on all luxury
              transfers during the World Cup season. Whether it's airport pickup,
              stadium drop-off, or city rides - travel in comfort without breaking
              the bank.
            </p>

            <p className="mb-6 md:mb-8 text-gray-300 text-base md:text-lg lg:text-xl italic">
              Book now and ride like a World Cup VIP.
            </p>

            <div className="flex flex-row gap-3 md:gap-4 justify-center mx-auto">
              <a
                href="/booknow"
                className="bg-white text-black px-4 md:px-6 lg:px-8 py-2.5 md:py-3 rounded-full text-sm md:text-base font-semibold hover:bg-gray-100 transition transform hover:scale-105 text-center whitespace-nowrap"
              >
                BOOK NOW
              </a>

              <a
                href="/fifa-world-cup-2026-transportation"
                className="border border-white text-white px-4 md:px-6 lg:px-8 py-2.5 md:py-3 rounded-full text-sm md:text-base font-semibold hover:bg-white hover:text-black transition transform hover:scale-105 text-center whitespace-nowrap"
              >
                READ MORE
              </a>
            </div>
          </div>
        </div>
      </section>

      
      <div className="text-center py-8 sm:py-12 px-4">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black mb-4">Our Fleet</h2>
          <p className="text-base sm:text-lg text-gray-900">Top-Rated Rides & Transfers</p>
        </div>
      {/* Vehicle Showcase Cards Section */}
      <VehicleShowcaseCards />


      {/* Blog Section */}
      <BlogSection />


      {/* FAQ Section */}
      <FAQ />

      <Footer/>
            
    </>
  );
}

export default Home;



